import { ChatId } from 'src/app/store/samwin/chats/models/chat-id';
import { Command } from './command';

export class CloseChatCommand extends Command {
   public static readonly commandType: string = 'samwin/close-chat';

   public constructor(public chatId: ChatId) {
      super(CloseChatCommand.commandType, chatId);
   }
}
